<div *ngIf="!config?.v2" class="testimonials-section">
  <div class="heading">What Monthly Contributors Say</div>

  <div class="donor-note">
    <ngx-glide [showArrows]="false" [gap]="20" [showBullets]="false" [perView]="3" [breakpoints]="breakpoints" [dragThreshold]="false"
              [listenToEvents]="true" (ranBefore)="swiped($event)">
      <div *ngFor="let item of testimonials" class="desc" [ngClass]="{'active': selectedDonor?.name===item?.name}" (click)="selectDonor(item)">
        <div class="text">{{item.content}}</div>
      </div>
    </ngx-glide>
  </div>

  <div class="donor">
    <div *ngFor="let item of testimonials" class="donor-image" [ngClass]="{'active': selectedDonor?.name===item?.name}" (click)="selectDonor(item)">
      <div class="image"><img loading="lazy" [attr.data-src]="item?.image" alt=""/></div>
    </div>
  </div>

  <div class="selected-donor">
    <div class="name">{{selectedDonor?.name}}</div>
    <div class="text">Monthly Contributor</div>
  </div>
</div>


<div *ngIf="config?.v2" class="testimonials v2">
  <div class="heading">What Monthly Contributors Say</div>
  <div class="donor-note">
    <ngx-glide [startAt]="startAt" [showArrows]="false" [showBullets]="false" [arrowLeftLabel]="''" [arrowRightLabel]="''" perView="3" [bound]="true" [gap]="20" [breakpoints]="breakpointsV2" [dragThreshold]="true">
      <div class="widget" *ngFor="let item of testimonials">
        <div class="text">{{item.content}}</div>
        <div class="image"><img loading="lazy" [attr.data-src]="item?.image" alt=""/><div class="name">{{item?.name}}</div></div>
      </div>
    </ngx-glide>
  </div>
</div>